import {type FC, useMemo} from 'react';
import {useGetColumnCategories} from '../../../../../../core/repositories/columnRepository';
import {cn} from '../../../../../../lib/classname';
import {SpTopBottomBanner} from '../../../../../../shared/components/Banner/SpTopBottomBanner';
import {RegularCarousel} from '../../Carousel/Regular';
import {
  COLUMNS_BY_ROOT_CATEGORY,
  COLUMNS_LATEST,
  COLUMNS_SPONSORED,
} from '../../routes';
import {RankingCarousel} from './RankingCarousel';
import {TopCarousel} from './TopCarousel';

type Props = {
  className?: string;
};
export const Carousels: FC<Props> = ({className}) => {
  const {data: categories} = useGetColumnCategories({});

  const categoriesToDisplay = useMemo(() => {
    if (!categories?.ok) return [];
    return categories.value.categories.filter(
      (category) => category.category.slug !== 'sponsored',
      // due to issue#8845
    );
  }, [categories]);

  return (
    <div className={cn('w-full flex flex-col', className)}>
      <TopCarousel />

      <div className="flex pc:hidden justify-center bg-white pt-8 pb-16">
        <SpTopBottomBanner type="top" />
      </div>

      <RankingCarousel />

      <RegularCarousel
        queryParam={{}}
        title="新着コラム"
        viewMoreLink={COLUMNS_LATEST}
      />

      <RegularCarousel
        queryParam={{type: 'nativeAd'}}
        viewMoreLink={COLUMNS_SPONSORED}
        title="企業コラム"
        description="就活に役立つノウハウを幅広く提供。就活、選考対策のブラッシュアップにつなげよう！"
      />

      <div className="flex pc:hidden justify-center bg-white pt-8 pb-16">
        <SpTopBottomBanner type="bottom" />
      </div>

      {categoriesToDisplay.map(({category}) => (
        <RegularCarousel
          key={category.slug}
          queryParam={{category: category.slug}}
          viewMoreLink={COLUMNS_BY_ROOT_CATEGORY(category.slug)}
          title={category.name}
          description={category.description}
        />
      ))}
    </div>
  );
};
